module.exports = __webpack_public_path__ + "img/MO.c7b3b4c5.png";